import { TechemTheme } from '@techem/techem-theme';
import arrowIcon from 'presentation/assets/icons/svg/arrow.svg';
import React from 'react';
import { Link } from 'react-router-dom';
import { useStyletron } from 'styletron-react';
import { styled } from 'baseui';

const StyledLink = styled(Link, {
  color: TechemTheme.colors.primary,
  cursor: 'pointer',
  ':focus': {
    textDecoration: 'underline',
    color: TechemTheme.colors.primary
  },
  ':after': {
    content: `url(${arrowIcon})`,
    marginLeft: '5px'
  }
});

interface ExternalArrowLinkProps {
  url: string;
}

const ExternalArrowLink: React.FC<ExternalArrowLinkProps> = ({ url, children }) => {
  const [css] = useStyletron();

  return (
    <StyledLink to={url} target={'_blank'}>
      <span className={css({ color: TechemTheme.colors.primary })}>
        <strong>{children}</strong>
      </span>
    </StyledLink>
  );
};

export default ExternalArrowLink;
